import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
  }

  .group {
    display: inline-flex;
    align-items: stretch;
    gap: 0;
    border: var(--sm-line, 1.5px) solid var(--border-subtle, var(--color-gray-3));
    border-radius: var(--radius-md, 12px);
    background: var(--surface-raised, var(--color-white));
    overflow: hidden;
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-xs, 0.25rem);
    /* 44px minimum so this is usable on a phone, which is where a theme
       switch is most likely to be reached for. */
    min-width: 1.5rem;
    min-height: 1.5rem;
    padding: 0 var(--spacing-sm, 0.5rem);
    border: 0;
    background: transparent;
    color: var(--on-surface-muted, var(--color-gray-6));
    cursor: pointer;
    font: inherit;
    font-size: var(--font-size-b3, 14px);
  }

  button + button {
    border-left: var(--sm-line, 1.5px) solid var(--border-subtle, var(--color-gray-3));
  }

  button[aria-checked='true'] {
    background: var(--surface-hover, var(--color-gray-2));
    color: var(--on-surface, var(--color-gray-9));
    font-weight: var(--font-weight-medium, 500);
  }

  button:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: -2px;
  }

  svg {
    width: .75rem;
    height: .75rem;
    flex: none;
    /* currentColor so the icons follow the active/inactive text colour, and
       therefore the theme. */
    fill: currentColor;
  }

  /* Label is supplementary; on narrow screens the icons carry the meaning. */
  @media (max-width: 768px) {
    .label {
      display: none;
    }
  }

  :host([compact]) .label {
    display: none;
  }
`;
